
export var  WorkGroup = {
    requestedDate:"",
    groupName: "",
    groupAlias: "",
    privacySetting:"Public",
    groupType:"Others",
    description:"",
    scope: "",
    startDate:"",
    endDate:"",
    groupStatus: "Active",
    hrComments: "",
    groupComments: "",
    communityPage: "",
    approval:"pending",
    Members: [],
    lastEditedBy:[]
};